<template>
  <ModalV2
    title="Esto es lo que te estarás perdiendo"
    :close-icon="icons.close"
    :visible="visible"
    @close="close"
  >
    <template #body>
      <div class="flex-container w-100 align-center text-center">
        <img
          alt="An image"
          class="mbs flex-container align-center row"
          :src="icons.commonLargeCancel"
        />
      </div>
      <div class="flex-container align-center">
        <div class="flex-dir-column">
          <div
            v-for="(pointCopy, index) in unPrettierNuggets.getPoints(
              subscription,
            )"
            :key="index"
            class="mts mbm column pll"
          >
            <img alt="An image" class="mrs" :src="icons.commonSmallCheckBlue" />
            <span class="text-medium text-black" v-html="pointCopy"></span>
          </div>
          <p class="text-small text-center">
            {{ unPrettierNuggets.ifYouCancelCopy(subscription) }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row align-center">
        <div class="column shrink">
          <button class="mbn button tiny secondary hollow" @click="next">
            Continuar con la cancelación
          </button>
        </div>
        <div class="column shrink">
          <button
            type="button"
            class="button tiny mbn prm plm text-small"
            @click="close"
          >
            Mantener Premium
          </button>
        </div>
      </div>
    </template>
  </ModalV2>
</template>

<script>
import ModalV2 from '../../../../shared/Modal/ModalV2.vue';

export default {
  components: {
    ModalV2,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unPrettierNuggets: {
        getPoints: (subscription) => {
          const socialMediaBlock = [
            `<strong>150,000+</strong> plantillas para redes sociales y herramientas de diseño`,
            `<strong>10,000+</strong> plantillas de tarjetas de presentación y herramientas de diseño`,
            `<strong>40,000+</strong> plantillas de póster, volante, papel membretado y más`,
          ];
          const perpStorAndPremium = [
            `Almacenamiento perpetuo de tus archivos`,
            `Plantillas prémium`,
          ];
          const website = [
            `<strong>Mobile-friendly Website</strong> con tu logotipo`,
          ];
          switch (subscription.subscriptionType) {
            case 'WebHosting':
              return [
                `Sitio web diseñado profesionalmente.`,
                `Sitio editable mediante WordPress CMS`,
                `Nombre de dominio`,
                `Hosting`,
                `Sitio web personalizado con tu logo.`,
              ];
            case 'LogoEditor':
              break;
            case 'SocialMediaEditor':
              break;
            case 'VipCustomerService':
              return [
                `Telefono VIP dedicato 24/7 y llamadas para compartir pantalla`,
                `Todos tus emails serán priorizados`,
                `Obtén Soporte Premium para todas tus preguntas`,
                `Nuestro equipo puede ayudarte a comunicarte con los diseñadores para conseguir el diseño perfecto.`,
              ];
            case 'PerpetualStorage':
              return [
                `Almacenamiento perpetuo de tus archivos de diseño en DesignCrowd`,
              ];
            case 'ProDesignerSupport':
              break;
            case 'SocialMediaDesign':
              return [
                `Diseños para redes sociales creados mensualmente por nuestros diseñadores y hechos para ti.`,
                `Diseños personalizados para Facebook e Instagram`,
                `Archivos Estándar de Industria`,
                `Soporte de Email 24/7`,
                `Tiempo de entrega de 2 días`,
              ];
            case 'PremiumDesignPack':
              return [
                `<strong>Logo editor</strong> con ediciones y descargas ilimitadas`,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            case 'LogoAndMorePackage1':
              return [...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage2':
              return [...website, ...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage3':
              return [
                `<strong>Diseños para redes sociales creados por nuestros diseñadores y hechos para ti.</strong>`,
                ...website,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            default:
              break;
          }

          return [];
        },
        ifYouCancelCopy: (subscription) => {
          return `Si cancelas tu suscripción, después de ${subscription.renewalDateCopy} perderás todos tus beneficios premium`;
        },
      },
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    next() {
      this.$emit('next');
    },
  },
};
</script>
